import { clsx as originalClsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Utility for constructing className strings conditionally.
 *
 * Merges Tailwind CSS classes without style conflicts.
 *
 * @see https://github.com/lukeed/clsx
 * @see https://github.com/dcastil/tailwind-merge
 */
export function clsx(...classNames) {
    return twMerge(originalClsx(classNames));
}
//# sourceMappingURL=clsx.js.map